import { Component, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextMenuItem } from '../../models/context-menu.models';

@Component({
  selector: 'app-context-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './context-menu.component.html',
})
export class ContextMenuComponent {
  visible = model.required<boolean>();
  position = input.required<{ x: number; y: number }>();
  menuItems = input<ContextMenuItem[]>([]); 
}
